<template>
  <div id="app">
    <!-- 火箭 -->
    <div id="upward" v-show="isShowRocket" @click="returnTop">
      <img src="@/assets/images/huojian.png" alt="" />
    </div>
    <TopBar
      v-show="
        $route.path == '/welcome' && $store.state.userFillState == '0'
          ? false
          : true
      "
    ></TopBar>
    <router-view />
    <!-- <Footer></Footer> -->
    <Login v-show="$store.state.isShowLoginBox"></Login>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import TopBar from "./components/TopBar.vue";
import Footer from "./components/Footer.vue";
import Login from "./components/Login.vue";
export default {
  computed: {
    listMessageData() {
      return this.$store.state.message;
    },
  },
  watch: {
    listMessageData(newVal, oldVal) {
      let object = JSON.parse(newVal.data);
      let message = object.messages;
      console.log(object);
      if (object.state == 12345) {
        return;
      }
      if (object.state == 1001) {
        if (!this.$store.state.isShowLoginExpiredBox) {
          return;
        }
        this.$store.state.isShowLoginExpiredBox = false;
        this.$store.state.isServerReconnection = false;
        this.$confirm("登录已失效", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            localStorage.removeItem("user-token");
            localStorage.removeItem("user-id");
            localStorage.removeItem("user-img");
            localStorage.removeItem("user-nickname");
            localStorage.removeItem("user-fillState");

            this.$store.state.redirectUrl = window.location.pathname;
            this.$store.state.isShowLoginBox = true;
            this.$store.state.isShowTopBarNoLoginBox = true;
            this.$store.state.isServerReconnection = true;
            this.$store.state.isShowLoginExpiredBox = true;
          })
          .catch(() => {
            this.$store.state.isServerReconnection = true;
            this.$store.state.isShowLoginExpiredBox = true;
          });

        return;
      }
      if (object.state == 999) {
        this.$store.state.isServerReconnection = false;
        this.$confirm(
          object.content +
            "下线时间：" +
            this.dateToString(new Date(object.date)),
          object.title,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.changeLoginBox(true);
            this.changeTopBarNoLoginBox(true);
            localStorage.removeItem("user-id");
            localStorage.removeItem("user-img");
            localStorage.removeItem("user-nickname");
            localStorage.removeItem("user-fillState");
            localStorage.removeItem("user-token");
            this.$store.state.isServerReconnection = true;
          })
          .catch(() => {
            this.$store.state.isServerReconnection = true;
          });
        return;
      }
      //判断是否在消息页面
      if (this.$route.path !== "/messageCenter") {
        this.$store.commit("changeMsgSum", this.$store.state.msgSum + 1);

        if (object.state == 88) {
          //系统消息
          this.$notify({
            title: "系统通知",
            message: `<span >${message[0].content}</span>`,
            dangerouslyUseHTMLString: true,
            position: "bottom-right",
          });
        } else if (object.state == 1) {
          //普通消息
          this.$notify({
            title: "新消息",
            message: `<span >${message[0].content}</span>`,
            dangerouslyUseHTMLString: true,
            position: "bottom-right",
          });
        }
      }
    },
  },
  data() {
    return {
      ds: null,
      isShowRocket: false,
    };
  },
  components: {
    TopBar,
    Footer,
    Login,
  },

  mounted() {
    window.addEventListener("scroll", () => {
      var top = document.documentElement.scrollTop;

      if (top >= 1000) {
        this.isShowRocket = true;
      } else {
        this.isShowRocket = false;
      }
    });
  },
  methods: {
    ...mapMutations([
      "changeLoginBox",
      "changeTopBarNoLoginBox",
      "changeDefaultLoginState",
    ]),
    dateToString(timeObj) {
      let str = "";
      let year = timeObj.getFullYear();
      let month = timeObj.getMonth() + 1;
      let date = timeObj.getDate();
      let hour = timeObj.getHours();
      let minute = timeObj.getMinutes();

      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(date) < 10) {
        date = "0" + date;
      }
      if (parseInt(hour) < 10) {
        hour = "0" + hour;
      }
      if (parseInt(minute) < 10) {
        minute = "0" + minute;
      }
      str = year + "年" + month + "月" + date + "日 " + hour + ":" + minute;

      return str;
    },

    returnTop() {
      if (this.ds == null) {
        this.ds = setInterval(() => {
          scrollBy(0, -60); //往上移动60像素距离

          if (document.documentElement.scrollTop === 0) {
            clearInterval(this.ds);
            this.ds = null;
          }
        }, 10);
      }
    },
  },
};
</script>


<style>
#upward {
  position: fixed;
  right: 5%;
  bottom: 20%;
}

#upward img {
  width: 50px;
  cursor: pointer;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* position: fixed;
  width: 100%;
  height: 100%; */
}
body,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
body {
  background-color: #f5f5f5;
}
input {
  outline: none;
  background: transparent;
  border: none;
  outline: medium;
}
</style>
